export const environment = {
	production: true,
	mock: false,
	tracking: true,
};
